import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import 'dayjs/locale/ru';
import { getRightDate } from "../../functions/serviceFunctions";
dayjs.extend(weekday);
dayjs.extend(weekOfYear);
dayjs.extend(isSameOrAfter)


dayjs.locale('ru');

const getWeekday = (date) => {
    const weekday = date.$W;
    if (weekday === 0) return 6;
    return weekday - 1;
}
export const getNumberOfDaysInPeriod = (initialDate, period) => {
    const startDate = dayjs(initialDate);
    const endDate = dayjs(initialDate).add(period, 'month');

    return endDate.diff(startDate, 'day');
};

export const currentPeriodDays = (periodDays, initialDate) => [...Array(periodDays)].map((day, index) => {
    const date = dayjs(initialDate).date(initialDate.date()).add(index, 'day')
    return {
        date: date,
        dayOfMonth: date.format('D'),
        isCurrentPeriod: true,
    }
});

export const daysForPreviousPeriod = (initialDate, periodDays) => {
    const firstDayOfTheMonthWeekday = getWeekday(periodDays[0].date);
    const previousMonth = dayjs(initialDate).date(1).subtract(1, 'month');

    const visibleNumberOfDaysFromPreviousMonth = firstDayOfTheMonthWeekday;//Если первый день месяца воскр, инициализируется значения 6. Значит пред. 6 дней в неделе не из этого периода. Если понедельник то 0.
    const previousMonthLastMondayDayOfMonth = dayjs(periodDays[0].date)
        .subtract(visibleNumberOfDaysFromPreviousMonth, "day")
        .date();
    return [...Array(visibleNumberOfDaysFromPreviousMonth)].map((day, index) => {
        return {
            date: dayjs(
                `${previousMonth.year()}-${previousMonth.month() + 1}-${previousMonthLastMondayDayOfMonth + index
                }`, 'YYYY-MM-DD'
            ),
            dayOfMonth: previousMonthLastMondayDayOfMonth + index,
            isCurrentPeriod: false
        };
    });
}

export const daysForNextPeriod = (initialDate, periodDays, period) => {
    const lastDayOfTheMonthWeekday = getWeekday(periodDays[periodDays.length - 1].date);

    const nextMonth = dayjs(initialDate).add(period, 'month');

    const visibleNumberOfDaysFromNextMonth = 6 - lastDayOfTheMonthWeekday;
    return [...Array(visibleNumberOfDaysFromNextMonth)].map((day, index) => {
        return {
            date: dayjs(
                `${nextMonth.year()}-${nextMonth.month() + 1}-01`, 'YYYY-MM-DD'
            ).add(index, 'day'),
            dayOfMonth: index + 1,
            isCurrentPeriod: false
        };
    })
}

export const getWeekDays = (days) => days.reduce((acc, day) => {
    let weekDay = getWeekday(day.date);
    if (!acc[weekDay]) {
        acc[weekDay] = [];
    }
    acc[weekDay].push(day);
    return acc;
}, {});

export const getWeekNumbers = (weekDays) => weekDays[0].map((day) => {
    return {
        date: day.date,
        weekNumber: dayjs(day.date).week()
    }
});

export const isPast = date => dayjs(date).isBefore(dayjs(), 'day');

export const isNotThisMonthAndYear = (date, initialDate) => {
    return dayjs(date).year() !== dayjs(initialDate).year() || dayjs(date).month() !== dayjs(initialDate).month();
}

export const isPastWeek = date => dayjs(date).isBefore(dayjs(), 'week')

export const isCurrentWeekAndYear = (date) => {
    return dayjs(date).isSame(dayjs(), 'year') && dayjs(dayjs(date).locale('ru').week()).isSame(dayjs().locale('ru').week());
}

export const isFirstDayOfTheCurrentWeek = (date) => {
    if (!isCurrentWeekAndYear(date)) return
    return dayjs(date).locale('ru').weekday() === 0;
}

export const isLastDayOfTheCurrentWeek = (date) => {
    if (!isCurrentWeekAndYear(date)) return
    return dayjs(date).locale('ru').weekday() === 6;
}

export const isCurrentDay = (date) => {
    return dayjs(date).isSame(dayjs(), 'day');
}

const capitalize = (s) => {
    if (typeof s !== 'string') return '';
    return s.charAt(0).toUpperCase() + s.slice(1);
};

// The quarter, half-year and year views are whole weeks in rows of equal length, starting at the week
// getRightDate picks for their date: [rows, weeks in a row] by the number of months shown. They move a week
// at a time, so a row can start and end in the middle of a month.
const ROWS_OF_WEEKS = { 3: [1, 14], 6: [2, 13], 12: [3, 18] };

// A heading names the month and spans its weeks; a week belongs to the month of its Thursday. A month cut by
// a row's edge gets a heading there too, with only its short name when it has a single week in the row.
const monthHeadings = (weekdays) => weekdays[3].reduce((headings, { date }) => {
    const last = headings[headings.length - 1];
    if (last && last.monthNum === date.month() && last.year === date.year()) {
        last.monthLength++;
        return headings;
    }
    const heading = { monthLength: 1, monthNum: date.month(), year: date.year() };
    const first = dayjs(new Date(date.year(), date.month(), 1));
    heading.date = () => (heading.monthLength === 1
        ? <span className="bold">{capitalize(first.format("MMM"))}</span>
        : <span><span className="bold">{capitalize(first.format("MMMM"))}</span> {first.format("YYYY")}</span>);
    headings.push(heading);
    return headings;
}, []);

export const periodRows = (initialDate, period) => {
    const [rows, weeks] = ROWS_OF_WEEKS[period];
    const days = currentPeriodDays(rows * weeks * 7, getRightDate(initialDate));
    const periods = [...Array(rows)].map((_, row) => {
        const weekdays = getWeekDays(days.slice(row * weeks * 7, (row + 1) * weeks * 7));
        return { weekdays, weekNumbers: getWeekNumbers(weekdays), monthsLength: monthHeadings(weekdays) };
    });

    return { days, periods };
}
